if (!customElements.get('view-changer')) {
  class ViewChanger extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.tagName === 'BUTTON') this.changeView(e);
      });
    }

    changeView(e) {
      const productGrids = this.dataset.sectionLimited ? this.closest('section').querySelectorAll('.product-grid-view') : document.querySelectorAll('.product-grid-view');
      
      if (e.target.dataset && e.target.dataset.view && productGrids.length) {
        this.dataset.view = e.target.dataset.view;
        productGrids.forEach((productGrid) => {
          productGrid.style.setProperty('--columns-mobile', `repeat(${e.target.dataset.view}, minmax(0, 1fr))`);
          productGrid.setAttribute('data-view', e.target.dataset.view);
        });
      }
    }
  }
  customElements.define('view-changer', ViewChanger);
}